/**
 * 距离计算工具类
 * 使用 Haversine 公式计算地球表面两点间的直线距离
 * 与后端 DistanceCalculationUtil 保持一致的实现
 */

/** 地球半径（米） */
const EARTH_RADIUS_METERS = 6371000;

/**
 * 角度转弧度
 */
function toRadians(degrees: number): number {
    return degrees * (Math.PI / 180);
}

/**
 * 计算两点之间的直线距离（使用Haversine公式）
 * 与后端 DistanceCalculationUtil.calculateStraightLineDistance 逻辑一致
 * 
 * @param lat1 纬度1
 * @param lon1 经度1
 * @param lat2 纬度2
 * @param lon2 经度2
 * @returns 距离（米）
 */
export function calculateDistance(
    lat1: number,
    lon1: number,
    lat2: number,
    lon2: number
): number {
    const dLat = toRadians(lat2 - lat1);
    const dLon = toRadians(lon2 - lon1);
    
    const a =
        Math.sin(dLat / 2) * Math.sin(dLat / 2) +
        Math.cos(toRadians(lat1)) * Math.cos(toRadians(lat2)) *
        Math.sin(dLon / 2) * Math.sin(dLon / 2);
    
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    return EARTH_RADIUS_METERS * c;
}

